




import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class State extends Vue {
    @Prop() id!: number;

    get translatedValue() {
        switch (this.id) {
            case 1:
                return "for sale";
                break;
            case 2:
                return "very good state";
                break;
            case 3:
                return "renovated";
                break;
            case 4:
                return "good state";
                break;
            case 5:
                return "to be refreshed";
                break;
            case 6:
                return "to be renovated";
                break;
            case 7:
                return "to be rebuild";
                break;
            case 8:
                return "to be destructed";
                break;
            case 9:
                return "unknown";
                break;
            case 10:
                return "Green estate";
                break;
            case 11:
                return "to be built";
                break;
            case 12:
                return "main work";
                break;
            case 13:
                return "new development";
                break;
            case 14:
                return "minor renovation";
                break;
            case 15:
                return "renovated";
                break;
            case 16:
                return "concept";
                break;
            case 17:
                return "developped";
                break;
            case 18:
                return "ready to start building";
                break;
            case 19:
                return "walls closed";
                break;
            case 20:
                return "construction achieved";
                break;
            case 21:
                return "delivered";
                break;
            case 22:
                return "plastered";
                break;
            case 23:
                return "ground to be prepared";
                break;
            case 24:
                return "ground ready for construction";
                break;
        }
        return "";
    }
}
